import { Capacitor } from '@capacitor/core'

interface CapacitorGlobal {
  PluginHeaders?: { name: string }[]
}

/**
 * Verifica se um plugin está registrado no binário nativo instalado.
 *
 * Necessário para bundles OTA rodando em binários antigos: o
 * `Capacitor.isPluginAvailable()` retorna true para plugins com wrapper JS
 * (ex.: @aparajita) mesmo quando o código nativo não existe no binário, e
 * chamar esses wrappers sem o nativo causa recursão infinita.
 */
export const hasNativePlugin = (name: string): boolean => {
  if (!Capacitor.isNativePlatform()) return false

  const cap = (window as { Capacitor?: CapacitorGlobal }).Capacitor
  return !!cap?.PluginHeaders?.some((header) => header.name === name)
}
